import React, { useState, useEffect } from "react";
import "../index.css";
import { Link } from "react-router-dom";
import { fetchFromAPI } from "../lib/api";

const UpcomingEvents = () => {
  const [current, setCurrent] = useState(0);
  const [sliderImages, setSliderImages] = useState([
    "/event.png",
    "/event.png",
    "/event.png",
  ]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const data = await fetchFromAPI("/fliers");
        if (data && Array.isArray(data) && data.length > 0) {
          const images = data.map((item) => item.imageUrl || item.image || item.url || item);
          setSliderImages(images);
        }
      } catch (err) {
        console.error("Failed to fetch fliers:", err);
      }
    };

    fetchImages();
  }, []);

  const prev = () =>
    setCurrent((i) => (i === 0 ? sliderImages.length - 1 : i - 1));
  const next = () =>
    setCurrent((i) => (i === sliderImages.length - 1 ? 0 : i + 1));

  return (
    <section className="bg-white w-full py-16 px-4 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

        {/* ── Left: Image Slider ── */}
        <div className="w-full lg:w-[44%] flex-shrink-0">

          {/* Decorative corner brackets wrapper */}
          <div className="relative">

            {/* Bottom-left corner accent */}
            <div className="absolute -bottom-3 -left-3 w-16 h-16 border-l-2 border-b-2 border-blue-600 z-10 pointer-events-none" />

            {/* Slider container */}
            <div className="relative rounded-sm overflow-hidden aspect-[4/5]">

              {sliderImages.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Event ${i + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ease-in-out ${i === current ? "opacity-100 z-10" : "opacity-0 z-0"
                    }`}
                />
              ))}

              {/* Scrim */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20 z-20 pointer-events-none" />

              {/* Prev Arrow */}
              <button
                onClick={prev}
                aria-label="Previous"
                className="absolute left-3 top-1/2 -translate-y-1/2 z-30
                  w-8 h-8 flex items-center justify-center
                  rounded-sm bg-white/80 backdrop-blur-sm
                  text-blue-600
                  hover:bg-white
                  transition-all duration-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              {/* Next Arrow */}
              <button
                onClick={next}
                aria-label="Next"
                className="absolute right-3 top-1/2 -translate-y-1/2 z-30
                  w-8 h-8 flex items-center justify-center
                  rounded-sm bg-white/80 backdrop-blur-sm
                  text-blue-600
                  hover:bg-white
                  transition-all duration-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>

          {/* Slide Indicators */}
          <div className="flex items-center justify-center gap-1.5 mt-5">
            {sliderImages.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                aria-label={`Go to slide ${i + 1}`}
                className={`rounded-full transition-all duration-300 ${i === current
                  ? "bg-blue-600 w-5 h-1.5"
                  : "bg-gray-300 w-1.5 h-1.5 hover:bg-blue-300"
                  }`}
              />
            ))}
          </div>
        </div>

        {/* ── Right: Text Content ── */}
        <div className="flex flex-col items-start gap-5 lg:w-[56%]">

          {/* Eyebrow */}
          <div className="flex items-center gap-2">
            <span className="block w-7 h-px bg-blue-600" />
            <span className="text-blue-600 text-xs font-semibold tracking-widest uppercase">
              Upcoming Events
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Join Our Services,{" "}
            <span className="text-blue-600">Events</span> &amp; Programs
          </h1>

          {/* Description */}
          <p className="text-gray-500 text-base leading-relaxed max-w-sm">
            Find out the Holy Father's Plan for you
          </p>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3 mt-2 flex-wrap">
            <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200">
              <span className="flex items-center justify-center w-5 h-5 bg-white/20">
                <svg className="w-2.5 h-2.5 fill-white" viewBox="0 0 10 10">
                  <polygon points="3,1 9,5 3,9" />
                </svg>
              </span>
              Watch
            </button>

            <Link to="/UpcomingEvents">
              <button className="flex items-center gap-2 border border-blue-600 text-blue-600 hover:bg-blue-50 text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200">
                View Events
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default UpcomingEvents;